import React, { useState } from "react";
import PropTypes from "prop-types";

import MeasurementCalculatorConfig from "./MeasurementCalculator.config";
import MeasurementCalculatorSchema from "./MeasurementCalculator.schema";

import "../../../assets/stylesheets/toolBase.css";

/**
 * MeasurementCalculatorTool
 *
 * Helps users estimate measurements (sq ft, linear ft, counts)
 * based on simple inputs. Calculation logic will be layered in later.
 */
const MeasurementCalculatorTool = ({ category }) => {
  const { title, description, defaults, categoryOverrides, ctaLabel } =
    MeasurementCalculatorConfig;

  const categoryConfig = categoryOverrides?.[category] || {};
  const fields =
    categoryConfig.fields || MeasurementCalculatorConfig.fields;

  const [formData, setFormData] = useState({ ...defaults });
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Placeholder: measurement calculation logic
    setHasSubmitted(true);
  };

  return (
    <div className="tool measurement-calculator-tool">
      {/* =====================================================
          Header
         ===================================================== */}
      <header className="tool-header">
        <h1 className="tool-title">{title}</h1>
        <p className="tool-description">{description}</p>
      </header>

      {/* =====================================================
          Form
         ===================================================== */}
      <form style={{marginTop: -42 }} onSubmit={handleSubmit}>
        {fields.map((field) => (
          <div className="tool-form-row" key={field.name}>
            <label className="tool-label" htmlFor={field.name}>
              {field.label}
            </label>

            <input
              id={field.name}
              name={field.name}
              type={field.type || "number"}
              className="tool-input"
              placeholder={field.placeholder}
              value={formData[field.name]}
              onChange={handleChange}
            />
          </div>
        ))}

        {/* Actions */}
        <div className="tool-actions">
          <button type="submit" className="tool-button-primary">
            {ctaLabel}
          </button>
        </div>
      </form>

      {/* =====================================================
          Results (Placeholder)
         ===================================================== */}
      {hasSubmitted && (
        <section className="tool-results">
          <div className="tool-result-card">
            <strong>Estimated Measurements</strong>
            <p className="tool-muted">
              Calculated measurements will appear here once logic is implemented.
            </p>
          </div>

          <div className="tool-result-card">
            <strong>Next Steps</strong>
            <p className="tool-muted">
              A professional can verify measurements and handle installation.
            </p>
          </div>
        </section>
      )}
    </div>
  );
};

MeasurementCalculatorTool.propTypes = {
  category: PropTypes.string,
};

export default MeasurementCalculatorTool;
